import EnumClass, { build } from '../EnumClass';
import data, { LanguageProficiencyId, LanguageProficiencyData } from './data';
import * as Translations from './translations';

export class LanguageProficiency extends EnumClass<LanguageProficiencyId, LanguageProficiencyData> {
  public get getName() {
    return Translations.name[this.id];
  }
}

export const {
  list: LANGUAGE_PROFICIENCIES,
  getById: getLanguageProficiencyById,
  marshaller: LanguageProficiencyMarshaller,
  isId: isLanguageProficiencyId,
} = build<LanguageProficiencyId, LanguageProficiencyData, LanguageProficiency>(
  'LanguageProficiencyEnum',
  data,
  LanguageProficiency,
);
